import styled from "styled-components";

const StyledHome = styled.div`
  width: 100%;
  height: 100vh;
  object-fit: cover;
  .small {
    width: 375px;
    height: 375px;
  }
  .autocompleteBox {
    background-color: white;
    border: 1px solid #cccccc;
    border-radius: 8px;
  }
  .autocompleteItem {
    padding: 10px;
    &:hover {
      background-color: #cccccc;
    }
  }
  .loader {
    align-self: center;
  }

  .arrows {
    margin: 15px;
    width: 35px;
    height: 35px;
  }
  .video-button {
    position: absolute;
    z-index: 100000000000000;
    color: white;
    left: 48%;
    top: 47%;
    font-size: 48px;
    display: ${(props) => props.videoButton && "none"};
    &:hover {
      opacity: 0.8;
    }
  }
  .downArrows {
    position: absolute;
    height: 100%;
    top: 0;
    left: 0;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: flex-end;
  }
  .large {
    width: 550px;
    height: 550px;
  }
  .background-image {
    object-fit: cover;
    left: 0;
    right: 0;
    width: 100vw;
    height: 100%;
    z-index: -1;
    display: block;
  }
  .background-image-alt {
    left: 0;
    right: 0;
    width: 100%;
    height: 100%;
    z-index: -1;
    display: block;
  }
`;

export default StyledHome;
